export default "__VITE_ASSET__CLziTTxs__"